"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (prefixedValue, value, keepUnprefixed) {
  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// d:/documents/git/krkrsvchk/krkrsvchk_web/~/material-ui/~/inline-style-prefixer/lib/utils/getPrefixedValue.js
// module id = 308
// module chunks = 1